import GlobalOverlay from '@components/GlobalOverlay';
import { createStyles, Popover } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import React from 'react';
import { SidebarItem, SidebarItemProps } from '../SidebarItem/SidebarItem';

const useStyles = createStyles(() => {
  return {
    dropdown: {
      padding: 0,
      // All set by dialog
      backgroundColor: 'transparent',
      border: 'none',
    },
  };
});
// Popover will reflect active state.
interface PoverSidebarItemProps
  extends Omit<SidebarItemProps, 'isActive' | 'onClick'> {
  Dialog: React.FC<{ close: VoidFunction }>;

  dropdownRef?: React.Ref<HTMLDivElement>;
  overlayRef?: React.Ref<HTMLDivElement>;
}

export function PopoverSidebarItem(props: PoverSidebarItemProps) {
  const { Dialog, overlayRef, dropdownRef, ...rest } = props;
  const { classes } = useStyles();
  const [open, toggle] = useDisclosure(false);
  return (
    <Popover
      classNames={classes}
      opened={open}
      onClose={toggle.close}
      closeOnClickOutside
      withinPortal
      offset={-4}
      position="right"
      transitionDuration={300}
    >
      <Popover.Target>
        <SidebarItem isActive={open} onClick={toggle.toggle} {...rest} />
      </Popover.Target>
      <Popover.Dropdown>
        <div ref={dropdownRef}>
          {/* use same zIndex as popover */}
          <GlobalOverlay
            zIndex="auto"
            onClick={toggle.close}
            ref={overlayRef}
          />
          <Dialog close={toggle.close} />
        </div>
      </Popover.Dropdown>
    </Popover>
  );
}
